export const getOrCreateWizardSessionRequestId = (): string => {
	if (typeof window !== 'undefined') {
		let requestId = sessionStorage.getItem('wizard_session_request_id');
		if (!requestId) {
			requestId = Date.now().toString();
			sessionStorage.setItem('wizard_session_request_id', requestId);
		}
		return requestId;
	}
	return '';
};
